import { render, staticRenderFns } from "./ContactDistributions.vue?vue&type=template&id=73bc9954&scoped=true"
import script from "./ContactDistributions.vue?vue&type=script&lang=js"
export * from "./ContactDistributions.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributions.vue?vue&type=style&index=0&id=73bc9954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc9954",
  null
  
)

export default component.exports